import merge from "lodash.merge";
import { ModelEventAction, } from "./types";
export class ModelEventConstructor {
    constructor(config) {
        this.modelState = new Map();
        this.metadataState = new Map();
        this.modelIndexMap = [];
        this.config = {
            onUpdate: config.onUpdate || (() => { }),
            onMetaUpdate: config.onMetaUpdate || (() => { }),
            onModelUpdate: config.onModelUpdate || (() => { }),
            onSystemEvent: config.onSystemEvent || (() => { }),
        };
    }
    onEvent(events) {
        let updateMetadata = false;
        let updateModels = false;
        const systemEvent = [];
        events.forEach((event) => {
            switch (event.action) {
                case ModelEventAction.UPDATE:
                    this.onUpdate.bind(this)(event);
                    updateModels = true;
                    break;
                case ModelEventAction.UPDATE_INDEX:
                    // TODO: Check if index the same
                    this.onUpdateIndex.bind(this)(event);
                    updateModels = true;
                    break;
                case ModelEventAction.DELETE:
                    this.onDelete.bind(this)(event);
                    updateModels = true;
                    break;
                case ModelEventAction.META:
                    updateMetadata = true;
                    this.onMeta.bind(this)(event);
                    break;
                case ModelEventAction.MANUAL_UPDATE:
                    systemEvent.push(event);
                    break;
                default:
                    throw new Error(`Unknown action "${event.action}"`);
            }
        });
        if (systemEvent.length) {
            this.config.onSystemEvent(systemEvent);
        }
        if (updateMetadata || updateModels) {
            this.updateInnerState.bind(this)();
        }
        if (updateModels) {
            this.updateModelsState.bind(this)();
        }
        if (updateMetadata) {
            this.updateMetadataState.bind(this)();
        }
    }
    cleanModelFromIndexList(id, cleanMap = false) {
        const oldIndexes = this.modelIndexMap
            .map((item, index) => [item, index])
            .filter(([itemId]) => itemId === id)
            .map(([, index]) => index);
        if (oldIndexes.length) {
            if (cleanMap) {
                this.modelState.delete(id);
            }
            oldIndexes.forEach((index) => {
                this.modelIndexMap.splice(index, 1);
            });
            return true;
        }
        return false;
    }
    onUpdateIndex(event) {
        const { id, index } = event.data;
        this.cleanModelFromIndexList(id);
        this.modelIndexMap.splice(index, 0, id);
    }
    onUpdate(event) {
        const { data, index, id, updateStrategy } = event.data;
        if (updateStrategy === "replace") {
            this.modelState.set(id, data);
            this.cleanModelFromIndexList(id);
            this.modelIndexMap.splice(index, 0, id);
        }
        else {
            this.modelState.set(id, merge(this.modelState.get(id) || {}, data));
            this.cleanModelFromIndexList(id);
            this.modelIndexMap.splice(index, 0, id);
        }
    }
    onDelete(event) {
        const { id } = event.data;
        this.modelState.delete(id);
        this.cleanModelFromIndexList(id, true);
    }
    onMeta(event) {
        const { data, id } = event.data;
        this.metadataState.set(id, data);
    }
    updateInnerState() {
        this.config.onUpdate({
            models: this.modelIndexMap.map((id) => this.modelState.get(id)),
            metadataState: Object.fromEntries(this.metadataState),
        });
    }
    updateMetadataState() {
        this.config.onMetaUpdate(Object.fromEntries(this.metadataState));
    }
    updateModelsState() {
        this.config.onModelUpdate(this.modelIndexMap.map((id) => this.modelState.get(id)));
    }
}
//# sourceMappingURL=constructor.js.map